<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Motivos</h5>
        </div>
        <emt-form ref="reason-form" v-bind:resource="config.api + '/reason/'" v-bind:items="itemsForm" v-on:register="reload" v-bind:updateData="update"></emt-form>
        <emt-grid ref="reason-grid" v-bind:resource="config.api + '/reason_full_data/'" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl"></emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default{
    name: 'emt-form-reason',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Motivo',
                    'placeholder': 'Ingrese motivo',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'area',
                    'label': 'Área',
                    'placeholder': 'Seleccione una área',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }
            ],
            itemsGrid: [
                {
                    'name': 'name',
                    'label': 'Motivo',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': {
                        'object': 'area',
                        'key': 'name'
                    },
                    'label': 'Área',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': null,
                    'ordering': true
                }
            ],
            config: Config,
            update: false,
            editUrl: '/EditReason/',
            deleteUrl: Config.api + '/reason/'
        }
    },
    methods: {
        reload: function () {
            this.$refs['reason-grid'].reload()
        },
        /*
        *esta funcion permite consultar y listar las unidades
        */
        getArea: function () {
            var self = this
            self.$http.get(Config.api + '/area/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getArea()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-reason.vue?6061bac4